window.M = require('materialize-css');
window.Slider = require('./slider').default;